import InputMask from "react-input-mask";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import querySearch from "stringquery";
import TagManager from "react-gtm-module";
import { invalidCpf, schema } from "./validations";
import { Checkbox, Error } from "../../styles/global";
import Button from "../../components/Button";
import Email from "../../components/Email";
import CustomHiddenInputs from "../../components/CustomHiddenInputs";
import HiddenInputs from "../../components/HiddenInputs";
import Options from "../../components/Options";

import {
  Container,
  Text,
  Form,
  InputContainer,
  Input,
  Title,
  ClassInit,
  Class,
  PersonalInput,
  PersonalInputContainer,
  SubmitInput,
} from "./style";

export default function Home({ email, setEmail }) {
  const url = "https://kenzie39049.activehosted.com/proc.php";
  const randomId = `${Date.now()}${Math.random()
    .toString(36)
    .substring(2)}`.slice(0, 20);
  sessionStorage.setItem("transactionId", randomId);

  const MANDATORY_FIELD_ERROR = "Campo obrigatório!";
  const location = useLocation();
  const { register, errors, watch, setError, clearErrors } = useForm({
    resolver: yupResolver(schema),
  });

  const [requirements, setRequirements] = useState("Sim");
  const firstName = watch(["firstname"]).firstname;
  const lastName = watch(["lastname"]).lastname;
  const displayName = watch(["field[155]"])["field[155]"];
  const gender = watch(["field[199]"])["field[199]"];
  const birthDate = watch(["field[16]"])["field[16]"];
  const [phoneValue, setPhoneValue] = useState("");
  const [cpfValue, setCpfValue] = useState("");
  const schooling = watch(["field[24]"])["field[24]"];
  const computer = watch(["field[12]"])["field[12]"];
  const about_employment = watch(["field[132]"])["field[132]"];
  const about_support = watch(["field[133]"])["field[133]"];
  const about_course = watch(["field[134]"])["field[134]"];
  const aboutYou = watch(["field[48]"])["field[48]"];
  const paymentMethod = watch(["field[222]"])["field[222]"];
  const privacy = watch(["privacy"]).privacy;

  const [utmSource, setUtmSource] = useState("");
  const [utmCampaign, setUtmCampaign] = useState("");
  const [utmMedium, setUtmMedium] = useState("");
  const [utmContent, setUtmContent] = useState("");
  const [hsaAd, setHsaAd] = useState("");
  const [hsaGrp, setHsaGrp] = useState("");
  const [hsaCam, setHsaCam] = useState("");
  const [hsaSrc, setHsaSrc] = useState("");
  const [origemLancamento, setOrigemLancamento] = useState("");
  const [campanhaLancamento, setCampanhaLancamento] = useState("");
  const [emailIndicador, setEmailIndicador] = useState("");
  const [nomeIndicador, setNomeIndicador] = useState("");
  const [indicator, setIndicator] = useState("");
  const [referral, setReferral] = useState("");
  const [recommendationId, setRecommendationId] = useState("");
  const [utmTerm, setUtmTerm] = useState("");

  const errorsLenght = Object.keys(errors).length;
  const validateEmail = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;

  const onFieldBlank = (e) => {
    if (
      computer === null ||
      about_employment === null ||
      about_support === null ||
      about_course === null ||
      privacy === false ||
      email === "" ||
      !validateEmail.test(email) ||
      String(firstName || "").trim().length === 0 ||
      String(lastName || "").trim().length === 0 ||
      displayName === "" ||
      gender === null ||
      birthDate === "" ||
      phoneValue === "" ||
      phoneValue.length > 15 ||
      cpfValue === "" ||
      cpfValue.length > 14 ||
      schooling === "" ||
      aboutYou === "" ||
      paymentMethod === ""
    ) {
      e.preventDefault();

      if (validateEmail.test(email) === false) {
        setError("email", {
          message: "O e-mail deve ser formatado corretamente",
        });
      }

      if (email === "") {
        setError("email", { message: MANDATORY_FIELD_ERROR });
      }

      if (privacy === false) {
        setError("privacy", {
          message: MANDATORY_FIELD_ERROR,
        });
      }

      if (computer === null) {
        setError("computer", {
          message: MANDATORY_FIELD_ERROR,
        });
      }

      if (String(firstName).trim().length === 0) {
        setError("firstname", {
          message: "Preencha este campo obrigatório com um nome válido.",
        });
      }

      if (firstName === "") {
        setError("firstname", { message: MANDATORY_FIELD_ERROR });
      }

      if (String(lastName).trim().length === 0) {
        setError("lastname", {
          message: "Preencha este campo obrigatório com um sobrenome válido.",
        });
      }

      if (lastName === "") {
        setError("lastname", { message: MANDATORY_FIELD_ERROR });
      }

      if (displayName === "") {
        setError("displayName", {
          message: MANDATORY_FIELD_ERROR,
        });
      }

      if (gender === null) {
        setError("gender", { message: MANDATORY_FIELD_ERROR });
      }

      if (birthDate === "") {
        setError("birthDate", { message: MANDATORY_FIELD_ERROR });
      }

      if (phoneValue !== undefined && phoneValue === "") {
        setError("phone", { message: MANDATORY_FIELD_ERROR });
      }

      if (phoneValue !== undefined && phoneValue.length > 15) {
        setError("phone", { message: "Deve conter apenas 11 números." });
      }

      if (cpfValue === "") {
        setError("cpf", { message: MANDATORY_FIELD_ERROR });
      }

      if (cpfValue.length > 14) {
        setError("cpf", { message: "Deve conter apenas 11 números." });
      }

      if (invalidCpf.includes(cpfValue)) {
        setError("cpf", { message: "CPF inválido" });
      }

      if (schooling === "") {
        setError("schooling", {
          message: MANDATORY_FIELD_ERROR,
        });
      }

      if (aboutYou === "") {
        setError("aboutYou", { message: MANDATORY_FIELD_ERROR });
      }

      if (paymentMethod === "") {
        setError("paymentMethod", {
          message: MANDATORY_FIELD_ERROR,
        });
      }

      return false;
    }
    if (computer === "Não") {
      localStorage.setItem("@req", "false");
    } else {
      localStorage.setItem("@req", "true");
    }

    localStorage.setItem("email", email);

    return true;
  };

  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: { event: "lead-inscricao" },
    });
  });

  useEffect(() => {
    const urlParams = querySearch(location.search);

    setUtmSource(urlParams.utm_source);
    setUtmMedium(urlParams.utm_medium);
    setUtmCampaign(urlParams.utm_campaign);
    setUtmContent(urlParams.utm_content);
    setHsaAd(urlParams.hsa_ad);
    setHsaGrp(urlParams.hsa_grp);
    setHsaCam(urlParams.hsa_cam);
    setHsaSrc(urlParams.hsa_src);
    setOrigemLancamento(urlParams.origem_lancamento);
    setCampanhaLancamento(urlParams.campanha_lancamento);
    setEmailIndicador(urlParams.EMAIL_DO_INDICADOR);
    setNomeIndicador(urlParams.NOME_DO_INDICADOR);
    setIndicator(urlParams.utm_indicator);
    setReferral(urlParams.utm_referral);
    setRecommendationId(urlParams.utm_recommendation_id);
    setUtmTerm(urlParams.utm_term);
    sessionStorage.setItem("influencerId", "no-tracking");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (computer !== null) {
      clearErrors("computer");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [computer]);

  useEffect(() => {
    if (privacy !== false) {
      clearErrors("privacy");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [privacy]);

  useEffect(() => {
    if (email !== "") {
      clearErrors("email");
    }

    if (validateEmail.test(email)) {
      clearErrors("email");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email]);

  useEffect(() => {
    if (firstName !== "" && String(firstName).trim().length !== 0) {
      clearErrors("firstname");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firstName]);

  useEffect(() => {
    if (lastName !== "" && String(lastName).trim().length !== 0) {
      clearErrors("lastname");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastName]);

  useEffect(() => {
    if (displayName !== "") {
      clearErrors("displayName");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayName]);

  useEffect(() => {
    if (gender !== null) {
      clearErrors("gender");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gender]);

  useEffect(() => {
    if (birthDate !== "") {
      clearErrors("birthDate");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [birthDate]);

  useEffect(() => {
    if (
      phoneValue !== undefined &&
      phoneValue !== "" &&
      phoneValue.length === 15
    ) {
      clearErrors("phone");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [phoneValue]);

  useEffect(() => {
    if (
      cpfValue !== undefined &&
      cpfValue !== "" &&
      cpfValue.length === 14 &&
      !invalidCpf.includes(cpfValue)
    ) {
      clearErrors("cpf");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cpfValue]);

  useEffect(() => {
    if (schooling !== "") {
      clearErrors("schooling");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schooling]);

  useEffect(() => {
    if (aboutYou !== "") {
      clearErrors("aboutYou");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aboutYou]);

  useEffect(() => {
    if (paymentMethod !== "") {
      clearErrors("paymentMethod");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentMethod]);

  return (
    <>
      <Container id="main">
        <Title>
          12 meses para iniciar a sua carreira na área de tecnologia
        </Title>

        <ClassInit> Início: 17 de Novembro de 2022</ClassInit>

        <Text>
          Bem vindo(a) ao processo seletivo da <Class>Kenzie.</Class> Por aqui
          você aprende programação <i>(front-end e back-end)</i> do ZERO em 12
          meses sem precisar de conhecimento prévio e ainda conta com
          oportunidades de de pagamento facilitado.
        </Text>

        <Text>
          Nosso CEO, Daniel Kriger, tem um vídeo para te dar uma explicação
          completa sobre o nosso processo seletivo:
        </Text>

        <iframe
          src="https://www.youtube.com/embed/UF6Ifkh7VCg?rel=0"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Kenzie Academy Brasil"
          description="Kenzie Academy Brasil"
        />

        <Form onSubmit={onFieldBlank} action={url} method="POST" validate>
          <HiddenInputs formId={168} />

          <Email
            inputRef={register}
            name="email"
            value={email}
            onChange={setEmail}
            error={errors.email?.message}
            label="E-mail:"
          />

          <h2>Pré-requisitos</h2>

          <Text>
            a&#41; Computador com pelo menos 8gb de memória RAM, 1.6GHz de
            processador e 256gb de armazenamento (SSD recomendável), além de
            internet banda larga de 10mb/s e uma webcam. Você tem o equipamento
            necessário?
          </Text>
          <div style={{ display: "none" }}>
            <InputContainer>
              <input
                type="text"
                value={requirements}
                name="field[13]"
                ref={register}
              />{" "}
            </InputContainer>
          </div>

          <Text>b&#41; Ter pelo menos 18 anos completos</Text>
          <Text>c&#41; Ter pelo menos ensino médio completo</Text>
          <Text>
            d&#41; Disponibilidade de horário: 9h às 15h, de segunda a sexta, e
            dedicação adicional de 10 horas/semana pelo período de 12 meses.
          </Text>
          <Text>Você atende aos requisitos anteriores?</Text>
          <InputContainer>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  value="Sim"
                  ref={register}
                  name="field[12]"
                  onChange={(e) => setRequirements(e.target.value)}
                />{" "}
                SIM
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  value="Não"
                  ref={register}
                  name="field[12]"
                  onChange={(e) => setRequirements(e.target.value)}
                />{" "}
                NÃO
              </label>
            </Checkbox>
          </InputContainer>
          <Error>{errorsLenght !== 0 && errors.computer?.message}</Error>

          <h2>Dados Pessoais</h2>
          <PersonalInputContainer>
            <PersonalInput>
              <label>
                Nome
                <input ref={register} name="firstname" />
              </label>
              <Error>{errors.firstname?.message}</Error>
            </PersonalInput>

            <PersonalInput>
              <label>
                Sobrenome
                <input ref={register} name="lastname" />
              </label>
              <Error>{errors.lastname?.message}</Error>
            </PersonalInput>
          </PersonalInputContainer>

          <PersonalInput>
            <label>
              Como deseja ser chamado(a)?
              <input ref={register} name="field[155]" />
            </label>
            <Error>{errors.displayName?.message}</Error>
          </PersonalInput>

          <Options>
            <legend>Gênero</legend>

            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[199]"
                  value="Feminino"
                />{" "}
                Feminino
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[199]"
                  value="Masculino"
                />{" "}
                Masculino
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[199]"
                  value="Transgênero"
                />{" "}
                Transgênero
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[199]"
                  value="Não binário"
                />{" "}
                Não binário
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[199]"
                  value="Prefiro não declarar"
                />{" "}
                Prefiro não declarar
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[199]"
                  value="Outro"
                />{" "}
                Outro
              </label>
            </Checkbox>
            <Error>{errors.gender?.message}</Error>
          </Options>

          <PersonalInputContainer>
            <PersonalInput>
              <label>
                Data Nascimento
                <input
                  type="date"
                  ref={register}
                  name="field[16]"
                  placeholder="dd-mm-yyyy"
                />
              </label>
              <Error>{errors.birthDate?.message}</Error>
            </PersonalInput>

            <PersonalInput>
              <label>
                Telefone Celular (com DDD)
                <InputMask
                  placeholder="41999999999"
                  mask="(99) 99999-9999"
                  maskChar=""
                  name="phone"
                  value={phoneValue}
                  onChange={(e) => setPhoneValue(e.target.value)}
                />
              </label>
              <Error>{errors.phone?.message}</Error>
            </PersonalInput>
          </PersonalInputContainer>

          <PersonalInput>
            <label>
              CPF (apenas os números)
              <InputMask
                mask="999.999.999-99"
                name="field[22]"
                value={cpfValue}
                onChange={(e) => setCpfValue(e.target.value)}
              />
            </label>
            <Error>{errors.cpf?.message}</Error>
          </PersonalInput>

          <PersonalInput>
            <label>
              Qual a sua escolaridade?
              <select ref={register} name="field[24]">
                <option selected> </option>
                <option value="Ensino Médio Incompleto">
                  Ensino Médio Incompleto
                </option>
                <option value="Ensino Médio Completo">
                  Ensino Médio Completo
                </option>
                <option value="Ensino Superior Cursando">
                  Ensino Superior Cursando
                </option>
                <option value="Ensino Superior Incompleto">
                  Ensino Superior Incompleto
                </option>
                <option value="Ensino Superior Completo">
                  Ensino Superior Completo
                </option>
                <option value="Pós-Graduação/Especialização">
                  Pós-Graduação/Especialização
                </option>
              </select>
            </label>
            <Error>{errors.schooling?.message}</Error>
          </PersonalInput>

          <h2>Conte um pouco mais sobre você</h2>

          <SubmitInput>
            <label>
              Conte para nós, em no mínimo 100 palavras, o porque deseja se
              tornar um(a) programador(a).
            </label>

            <textarea ref={register} name="field[48]" />

            <Error>{errors.aboutYou?.message}</Error>
          </SubmitInput>

          <SubmitInput>
            <label>Qual mensagem você gostaria de deixar para nós?</label>

            <textarea ref={register} name="field[49]" />
          </SubmitInput>

          <PersonalInputContainer>
            <SubmitInput>
              <label>Como deseja pagar o curso?</label>
              <select ref={register} name="field[222]">
                <option value="">Selecione</option>
                <option value="À Vista">
                  À Vista (R$17.600 - 20% de desconto)
                </option>
                <option value="Parcelado">
                  Parcelado (12x de R$1.800 - 10% de desconto)
                </option>
                <option value="Financiado">
                  Financiado (R$ 33 mil em 36 parcelas a partir de R$ 379)
                </option>
              </select>
              <Error>{errors.paymentMethod?.message}</Error>
            </SubmitInput>
          </PersonalInputContainer>

          <input type="hidden" name="field[186]" value={randomId} />

          <Input>
            <label>
              <input type="checkbox" name="privacy" ref={register} /> Na
              qualidade de Usuário, declaro que li, compreendi e estou de acordo
              com os{" "}
              <a
                href="https://formulario-kenzie.vercel.app/termos-condicoes"
                target="_blank"
                rel="noreferrer"
              >
                Termos de Uso e com a Política de Privacidade*
              </a>
            </label>
          </Input>
          <Error>{errors.privacy?.message}</Error>

          {errorsLenght !== 0 && <p>Preencha todos os campos obrigatórios</p>}

          <CustomHiddenInputs
            values={[
              utmSource,
              utmMedium,
              utmCampaign,
              utmContent,
              utmTerm,
              hsaAd,
              hsaGrp,
              hsaCam,
              hsaSrc,
              origemLancamento,
              campanhaLancamento,
              emailIndicador,
              nomeIndicador,
              indicator,
              referral,
              recommendationId,
            ]}
          />

          <Button type="submit">Enviar Inscrição</Button>
        </Form>
      </Container>
    </>
  );
}
